<div class="notification-container">
  <div class="notification-header">
    <div class="header-left">
      <span class="title">Notifications</span>
      <span class="notification-count" *ngIf="notificationService.totalUnreadCount$ | async">{{ notificationService.totalUnreadCount$ | async }}</span>
    </div>
    <button class="mark-all-as-read" (click)="markAllAsRead()" *ngIf="notifications.length > 0">Mark all as read</button>
  </div>

  <div class="notification-list" [appLoading]="isLoading" >
    <div *ngIf="notifications.length === 0" class="no-notifications">
      <div class="col-sm-12"
            style="padding: 20px 15px; margin-bottom: 20px; text-align: center;">
          <img src="../../../../../assets/images/Upfront Icon/Empty1.svg" style="width: 80px;" />
          <p style="color: #75787B; font-size: 20px; margin-top: 20px;">
            No new notifications.
          </p>
        </div>
    </div>
    <div *ngFor="let notification of notifications" class="notification-item" [class.read]="notification.read" (click)="openMyConversation(notification.patientId)">
      <img [src]="notification.type === 'follow' ? '/assets/images/client-messaging/FollowerAdded.svg' :notification.user.avatar" alt="User Avatar" class="notification-avatar">
      <div class="notification-content">
        <div class="notification-meta">
          <span class="notification-user-name">{{ notification.type === 'follow' ? 'Follow' : notification.user.name }}</span>
          <span class="notification-type" *ngIf="notification.type === 'incoming_sms'">Incoming SMS</span>
          <span class="notification-type" *ngIf="notification.type === 'incoming_email'">Incoming Email</span>
          <span class="notification-type" *ngIf="notification.type === 'follow'">Follower Added</span>
        </div>
        <p class="notification-message" *ngIf="notification.message">
          <span *ngIf="notification.type === 'incoming_email'" class="font-medium">Subject: <span [innerHTML]="notification.subject && notification.subject.length > 22 ? (notification.subject | slice:0:22) + '...' : notification.subject "></span></span>
          <span class="message" [innerHTML]="notification.message.length > 60 ? (notification.message | slice:0:60) + '...' : notification.message"></span>
        </p>
        <div class="message attachment-preview" *ngIf="notification.hasMMSAttachment && !notification.message">
          <i class="fa fa-paperclip attachment-icon"></i>
          <span>Attachment</span>
        </div>
        <span class="notification-time">{{ notification.timeAgo }}</span>
      </div>
    </div>
  </div>

  <div class="notification-footer"  (click)="viewAllNotifications()">
    <button >View all notifications</button>
  </div>
</div>